import { Component } from '@angular/core'

@Component({
  selector: 'app-payers',
  templateUrl: './payers.component.html',
  standalone: false
})
export class PayersComponent {}
